export enum ActionType {
    OPEN_MESSAGE="OPEN_QUOTE_MESSAGE"
}

interface IOpenMessage {
    type: ActionType.OPEN_MESSAGE,
    open: boolean
}

export type Action = IOpenMessage;